import { createContext, useContext, useReducer } from 'react';
import type { ReactNode } from 'react';
import { USER_FETCH, USER_LOGOUT } from './actionTypes';
import type { UserState, UserAction } from '@/types';

const UserContext = createContext<UserState | null>(null);

const UserDispatchContext = createContext<React.Dispatch<UserAction> | null>(null);

const initialState: UserState = {};

interface UserProviderProps {
  children: ReactNode;
}

export function UserProvider({ children }: UserProviderProps) {
  const [user, dispatch] = useReducer(userReducer, initialState);

  return (
    <UserContext.Provider value={user}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserContext.Provider>
  );
}

export function useUser(): UserState | null {
  return useContext(UserContext);
}

export function useUserDispatch(): React.Dispatch<UserAction> {
  const dispatch = useContext(UserDispatchContext);
  if (!dispatch) {
    throw new Error('useUserDispatch must be used within UserProvider');
  }
  return dispatch;
}

function userReducer(_user: UserState, action: UserAction): UserState {
  switch (action.type) {
    case USER_LOGOUT: {
      return initialState;
    }
    case USER_FETCH: {
      return {
        ...action.payload,
      };
    }
    default: {
      throw Error('Unknown action: ' + action);
    }
  }
}
